import { atom } from "recoil";

export const showSideDrawerViewDetails = atom({
    key: "sideDrawerViewDetails/showSideDrawerViewDetails",
    default: false,
});